<div class="dashboard-container">
  <div class="image-container">
    <img src="/assets/images/umbrella-hero-text.png" alt="Introducing our new Benefits Portal" />
  </div>
  <div class="content-container" *ngIf="overviewData; else isLoading">
    <div class="title-container">
      <h1 class="welcome-text">{{ Welcome }}</h1>
      <dxo-label-value
        [label]="Group"
        [values]="[overviewData.policyHolder]"
        [subValue]="'#' + overviewData.policyNumber"
      />
    </div>
    <div class="card-container">
      <dxo-card [bodyHeader]="QuickLinksHeader">
        <card-body>
          <div class="quick-link">
            <h3>{{ employerQuickLink.title }}</h3>
            <div class="link-container">
              <a target="_blank" [href]="employerQuickLink.link">{{ employerQuickLink.text }}</a>
              <a target="_blank" [href]="employerQuickLink.link" class="icon-link">
                <dxo-icon fontSize="16" color="blue">{{ quickLinkIcon }}</dxo-icon>
              </a>
            </div>
          </div>

          <div class="quick-link">
            <h3>{{ employeeQuickLink.title }}</h3>
            <div class="link-container">
              <a target="_blank" [href]="employeeQuickLink.link">{{ employeeQuickLink.text }}</a>
              <a target="_blank" [href]="employeeQuickLink.link" class="icon-link">
                <dxo-icon fontSize="16" color="blue">{{ quickLinkIcon }}</dxo-icon>
              </a>
            </div>
          </div>

          <div class="quick-link-w-image">
            <img src="/assets/images/podcast-image.png" alt="Working Forward Podcast" />
            <div>
              <h3>{{ podcastQuickLink.title }}</h3>
              <div class="link-container">
                <a target="_blank" [href]="podcastQuickLink.link">{{ podcastQuickLink.text }}</a>
                <a target="_blank" [href]="podcastQuickLink.link" class="icon-link">
                  <dxo-icon fontSize="16" color="blue">{{ quickLinkIcon }}</dxo-icon>
                </a>
              </div>
            </div>
          </div>
        </card-body>
      </dxo-card>

      <dxo-card *ngIf="hasContacts" bodyHeader="Symetra contacts" class="contacts-card">
        <card-body>
          <div *ngFor="let item of contactData" class="contact-container">
            <div class="contact-info-container">
              <img src="/assets/images/default-profile-image.svg" alt="Profile pic" />
              <div class="contact-info">
                <div class="name-number">
                  <dxo-label-value [label]="item.contactType" [values]="[item.name]" />
                  <dxo-button
                    [textButton]="true"
                    [href]="'tel:+1-' + item.phoneNumber"
                    [text]="item.phoneNumber"
                  ></dxo-button>
                </div>
              </div>
            </div>
            <div class="email-button">
              <dxo-button
                [primary]="item.primaryButton"
                icon="email"
                [iconColor]="item.primaryButton ? 'white' : 'blue'"
                [text]="item.email"
                [href]="'mailto:' + item.email"
              ></dxo-button>
              <dxo-button class="copy-button" (handleClick)="copyEmail(item.email)">
                <dxo-icon color="dark-grey" fontSize="24">{{ copyIcon }}</dxo-icon>
              </dxo-button>
            </div>
            <div *ngIf="item.showDivider" class="divider"></div>
          </div>
          <div class="contact-us">
            <span>{{ MissingContactText }}</span>
            <a href="">{{ ContactUs }}</a>
          </div>
        </card-body>
      </dxo-card>
      <div></div>
      <dxo-card><div id="dashboard-survey-card"></div></dxo-card>
    </div>
  </div>
  <ng-template #isLoading>
    <div class="loader-container">
      <dxo-circular-loader [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
    </div>
  </ng-template>
</div>
